// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/image.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/icons/sound.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div[data-role='speechSegment'],
div[data-role='imageCaption'],
div[data-role='soundCaption'] {
    display: block;
    font-size: 18px;
    background: #fafafa;
    line-height: 1.6;
    padding: 5px 10px;
    border-radius: 15px;
}

div[data-role='speechSegment'] div {
    display: inline;
}

div[data-role='speechSegment'] p,
div[data-role='imageCaption'] p,
div[data-role='soundCaption'] p {
    margin-bottom: 0;
}

div[data-role='speechSegment'].hasEmotion div {
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
}

.segmentMeta {
    display: flex;
    align-items: stretch;
    gap: 5px;
    margin-bottom: 4px;
    line-height: normal;
}

.segmentMeta .speaker {
    margin-right: 0;
    margin-bottom: 0;
}

.segmentMeta .emotionChip {
    margin-left: 0;
}

.emotionChip {
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    gap: 4px;
    padding: 2px 7px;
    margin-left: 4px;
    border-radius: 12px;
    line-height: 1.5;
    font-weight: 600;
    white-space: nowrap;
    color: var(--emotion-color, #333);
    background: color-mix(in srgb, var(--emotion-color, #333) 14%, #fff);
    border: 1px solid color-mix(in srgb, var(--emotion-color, #333) 35%, #fff);
    transition: all 0.2s ease;
}

.emotionChip .emoji {
    margin-left: 0;
    font-size: 1.05em;
    line-height: 1;
    display: inline-flex;
    align-items: center;
}

.emotionChip:hover {
    opacity: 0.8;
    transform: scale(1.05);
}

.emotionChip,
.emotionChip span,
.segmentMeta,
.segmentMeta span,
div[data-role='speechSegment']:hover .segmentMeta,
div[data-role='speechSegment']:hover .segmentMeta span,
div[data-role='speechSegment']:hover .emotionChip,
div[data-role='speechSegment']:hover .emotionChip span {
    text-decoration: none !important;
}

.segmentMeta .emotionChip {
    cursor: default;
}

div[data-role='speechSegment']:hover span,
div[data-role='imageCaption']:hover span,
div[data-role='soundCaption']:hover span {
    text-decoration: underline;
    cursor: pointer;
}

span[data-role='speechSubSegment'] {
    transition: all 0.2s ease;
}

span.bold {
    background: #ddd;
    border-radius: 5px;
    font-weight: bold;
    padding: 5px;
}

.speaker {
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    font-weight: bold;
    background: black;
    color: white;
    padding: 2px 7px;
    margin-right: 5px;
    border: 1px solid transparent;
    border-radius: 12px;
    line-height: 1.5;
}

.speaker.speaker_imageCaption,
.speaker.speaker_soundCaption {
    border-radius: 5px;
    color: transparent;
    background-color: #f00;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.speaker.speaker_soundCaption {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

div[data-role='speechSegment']:hover .speaker {
    text-decoration: none;
}

.ops {
    margin-top: 15px;
    display: flex;
    align-items: center;
}

.selectTranscript .dropDown {
    min-width: 200px;
}

.ops label {
    margin-right: 10px;
}

.ops input {
    margin-right: 5px;
}

.selectTranscript .selectTranscriptDropdownContainer {
    position: absolute;
}

#TranscriptRenderer {
    position: relative;
    border-top: 3px solid #1faeff;
    flex: 1 1;
    overflow: scroll;
    width: 100%;
}

#RecordingHeaderControls {
    box-sizing: border-box;
    font-size: 15px;
}

#RecordingHeaderControls > label {
    display: block;
    margin: 0;
    padding: 5px 10px;
    background: #fff;
    color: #666;
    cursor: pointer;
    transition: background-color 0.2s;
    border-style: solid;
    border-width: 1px;
    border-color: #ddd;
    white-space: nowrap;
}

#RecordingHeaderControls > label:hover {
    background-color: #f0f0f0;
}

#RecordingHeaderControls > label.active {
    background-color: #1faeff;
    color: #fff;
}

#RecordingHeaderControls > button {
    border: 1px solid #ddd;
    font-size: 14px;
    background: #fff;
    padding: 3px 8px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    white-space: nowrap;
}

#RecordingHeaderControls > button:hover {
    background-color: #f0f0f0;
}

#RecordingHeaderControls .badge {
    display: inline-flex;
    background: #1faeff;
    border-radius: 15px;
    height: 25px;
    width: 25px;
    font-size: 14px;
    margin-left: 5px;
    color: #fff;
    font-weight: bold;
    align-items: center;
    justify-content: center;
}

#RecordingHeaderControls > label.active .badge {
    background: #fff;
    color: #1faeff;
}

.transcriptOptionsPanel {
    position: fixed;
    top: 140px;
    right: 16px;
    z-index: 50;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    padding: 12px;
    width: 300px;
    max-height: calc(100vh - 160px);
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 13px;
}

.transcriptOptionsPanel .ops:first-child {
    margin-top: 0;
}

.transcriptOptionsPanel .ops.selectTranscript {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
}

.optionsPanelSelect {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 6px 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fff;
    font-size: 13px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
}

.transcriptOptionsPanel .transcriptFilters {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
}

.transcriptOptionsPanel .filtersHeading {
    margin: 0 0 2px;
    font-weight: bold;
}

.transcriptOptionsPanel .filterOption {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    cursor: pointer;
}

.transcriptOptionsPanel .filterOption input {
    margin: 0;
}

.transcriptOptionsPanel .optionsPanelMetaGroup {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
}

.transcriptOptionsPanel .recordingTagsContainer {
    margin: 0;
    gap: 4px;
}

.transcriptOptionsPanel .recordingTagsContainer .tag {
    font-size: 12px;
    background: #f5f6f7;
    border: 1px solid #eee;
}

.transcriptOptionsPanel .recordingTagsContainer .tag:hover {
    background: #e2e3e5;
}

#transcript.noTx [data-role='speechSegment'],
#transcript.noImgCap [data-role='imageCaption'],
#transcript.noSndCap [data-role='soundCaption'] {
    display: none;
}

#transcript p:first-child {
    margin-top: 0;
}

.speaker.highlight {
    border: 3px solid black;
    background: yellow;
    color: #000;
}

.speaker.editable {
    cursor: pointer;
    transition: all 0.2s ease;
}

.speaker.editable:hover {
    opacity: 0.8;
    transform: scale(1.05);
}

.button.autoScroll {
    display: none;
    position: fixed;
    bottom: 30px;
    right: 50px;
    border-radius: 15px;
}

.button.autoScroll.visible {
    display: block;
}

.ops.selectTranscript {
    position: relative;
}

.optionsPanelTranscript {
    z-index: 3;
}

.optionsPanelImageCaption {
    z-index: 2;
}

.optionsPanelSoundCaption {
    z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/Magor/Recording/Transcript.css"],"names":[],"mappings":"AAAA;;;IAGI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,oEAAoE;IACpE,0EAA0E;IAC1E,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;;;;;;;;IAQI,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,yDAAmD;IACnD,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,yDAAmD;AACvD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,SAAO;IACP,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd","sourcesContent":["div[data-role='speechSegment'],\ndiv[data-role='imageCaption'],\ndiv[data-role='soundCaption'] {\n    display: block;\n    font-size: 18px;\n    background: #fafafa;\n    line-height: 1.6;\n    padding: 5px 10px;\n    border-radius: 15px;\n}\n\ndiv[data-role='speechSegment'] div {\n    display: inline;\n}\n\ndiv[data-role='speechSegment'] p,\ndiv[data-role='imageCaption'] p,\ndiv[data-role='soundCaption'] p {\n    margin-bottom: 0;\n}\n\ndiv[data-role='speechSegment'].hasEmotion div {\n    display: flex;\n    align-items: center;\n    /* justify-content: space-between; */\n}\n\n.segmentMeta {\n    display: flex;\n    align-items: stretch;\n    gap: 5px;\n    margin-bottom: 4px;\n    line-height: normal;\n}\n\n.segmentMeta .speaker {\n    margin-right: 0;\n    margin-bottom: 0;\n}\n\n.segmentMeta .emotionChip {\n    margin-left: 0;\n}\n\n.emotionChip {\n    display: inline-flex;\n    align-items: center;\n    box-sizing: border-box;\n    gap: 4px;\n    padding: 2px 7px;\n    margin-left: 4px;\n    border-radius: 12px;\n    line-height: 1.5;\n    font-weight: 600;\n    white-space: nowrap;\n    color: var(--emotion-color, #333);\n    background: color-mix(in srgb, var(--emotion-color, #333) 14%, #fff);\n    border: 1px solid color-mix(in srgb, var(--emotion-color, #333) 35%, #fff);\n    transition: all 0.2s ease;\n}\n\n.emotionChip .emoji {\n    margin-left: 0;\n    font-size: 1.05em;\n    line-height: 1;\n    display: inline-flex;\n    align-items: center;\n}\n\n.emotionChip:hover {\n    opacity: 0.8;\n    transform: scale(1.05);\n}\n\n.emotionChip,\n.emotionChip span,\n.segmentMeta,\n.segmentMeta span,\ndiv[data-role='speechSegment']:hover .segmentMeta,\ndiv[data-role='speechSegment']:hover .segmentMeta span,\ndiv[data-role='speechSegment']:hover .emotionChip,\ndiv[data-role='speechSegment']:hover .emotionChip span {\n    text-decoration: none !important;\n}\n\n.segmentMeta .emotionChip {\n    cursor: default;\n}\n\ndiv[data-role='speechSegment']:hover span,\ndiv[data-role='imageCaption']:hover span,\ndiv[data-role='soundCaption']:hover span {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\nspan[data-role='speechSubSegment'] {\n    transition: all 0.2s ease;\n}\n\nspan.bold {\n    background: #ddd;\n    border-radius: 5px;\n    font-weight: bold;\n    padding: 5px;\n}\n\n.speaker {\n    display: inline-flex;\n    align-items: center;\n    box-sizing: border-box;\n    font-weight: bold;\n    background: black;\n    color: white;\n    padding: 2px 7px;\n    margin-right: 5px;\n    border: 1px solid transparent;\n    border-radius: 12px;\n    line-height: 1.5;\n}\n\n.speaker.speaker_imageCaption,\n.speaker.speaker_soundCaption {\n    border-radius: 5px;\n    color: transparent;\n    background-color: #f00;\n    background-image: url(../../assets/icons/image.svg);\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.speaker.speaker_soundCaption {\n    background-image: url(../../assets/icons/sound.svg);\n}\n\ndiv[data-role='speechSegment']:hover .speaker {\n    text-decoration: none;\n}\n\n.ops {\n    margin-top: 15px;\n    display: flex;\n    align-items: center;\n}\n\n.selectTranscript .dropDown {\n    min-width: 200px;\n}\n\n.ops label {\n    margin-right: 10px;\n}\n\n.ops input {\n    margin-right: 5px;\n}\n\n.selectTranscript .selectTranscriptDropdownContainer {\n    position: absolute;\n}\n\n#TranscriptRenderer {\n    position: relative;\n    border-top: 3px solid #1faeff;\n    flex: 1;\n    overflow: scroll;\n    width: 100%;\n}\n\n#RecordingHeaderControls {\n    box-sizing: border-box;\n    font-size: 15px;\n}\n\n#RecordingHeaderControls > label {\n    display: block;\n    margin: 0;\n    padding: 5px 10px;\n    background: #fff;\n    color: #666;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    border-style: solid;\n    border-width: 1px;\n    border-color: #ddd;\n    white-space: nowrap;\n}\n\n#RecordingHeaderControls > label:hover {\n    background-color: #f0f0f0;\n}\n\n#RecordingHeaderControls > label.active {\n    background-color: #1faeff;\n    color: #fff;\n}\n\n#RecordingHeaderControls > button {\n    border: 1px solid #ddd;\n    font-size: 14px;\n    background: #fff;\n    padding: 3px 8px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    white-space: nowrap;\n}\n\n#RecordingHeaderControls > button:hover {\n    background-color: #f0f0f0;\n}\n\n#RecordingHeaderControls .badge {\n    display: inline-flex;\n    background: #1faeff;\n    border-radius: 15px;\n    height: 25px;\n    width: 25px;\n    font-size: 14px;\n    margin-left: 5px;\n    color: #fff;\n    font-weight: bold;\n    align-items: center;\n    justify-content: center;\n}\n\n#RecordingHeaderControls > label.active .badge {\n    background: #fff;\n    color: #1faeff;\n}\n\n.transcriptOptionsPanel {\n    position: fixed;\n    top: 140px;\n    right: 16px;\n    z-index: 50;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n    padding: 12px;\n    width: 300px;\n    max-height: calc(100vh - 160px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    font-size: 13px;\n}\n\n.transcriptOptionsPanel .ops:first-child {\n    margin-top: 0;\n}\n\n.transcriptOptionsPanel .ops.selectTranscript {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n}\n\n.optionsPanelSelect {\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n    padding: 6px 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    background: #fff;\n    font-size: 13px;\n    color: #333;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.transcriptOptionsPanel .transcriptFilters {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n}\n\n.transcriptOptionsPanel .filtersHeading {\n    margin: 0 0 2px;\n    font-weight: bold;\n}\n\n.transcriptOptionsPanel .filterOption {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin: 0;\n    cursor: pointer;\n}\n\n.transcriptOptionsPanel .filterOption input {\n    margin: 0;\n}\n\n.transcriptOptionsPanel .optionsPanelMetaGroup {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n}\n\n.transcriptOptionsPanel .recordingTagsContainer {\n    margin: 0;\n    gap: 4px;\n}\n\n.transcriptOptionsPanel .recordingTagsContainer .tag {\n    font-size: 12px;\n    background: #f5f6f7;\n    border: 1px solid #eee;\n}\n\n.transcriptOptionsPanel .recordingTagsContainer .tag:hover {\n    background: #e2e3e5;\n}\n\n#transcript.noTx [data-role='speechSegment'],\n#transcript.noImgCap [data-role='imageCaption'],\n#transcript.noSndCap [data-role='soundCaption'] {\n    display: none;\n}\n\n#transcript p:first-child {\n    margin-top: 0;\n}\n\n.speaker.highlight {\n    border: 3px solid black;\n    background: yellow;\n    color: #000;\n}\n\n.speaker.editable {\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.speaker.editable:hover {\n    opacity: 0.8;\n    transform: scale(1.05);\n}\n\n.button.autoScroll {\n    display: none;\n    position: fixed;\n    bottom: 30px;\n    right: 50px;\n    border-radius: 15px;\n}\n\n.button.autoScroll.visible {\n    display: block;\n}\n\n.ops.selectTranscript {\n    position: relative;\n}\n\n.optionsPanelTranscript {\n    z-index: 3;\n}\n\n.optionsPanelImageCaption {\n    z-index: 2;\n}\n\n.optionsPanelSoundCaption {\n    z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
